/**
 * Public/marketing page actions — homepage, about, team, careers, help, docs, terms, privacy, landing, case studies
 */
export const PUBLIC_ACTIONS = {
  // Homepage
  HERO_CTA_CLICKED: 'hero_cta_clicked',
  SIGNUP_CTA_CLICKED: 'signup_cta_clicked',
  LEARN_MORE_CLICKED: 'learn_more_clicked',
  SECTION_VIEWED: 'section_viewed',

  // About
  PARTNER_CLICKED: 'partner_clicked',

  // Team
  TEAM_MEMBER_CLICKED: 'team_member_clicked',

  // Careers
  JOB_LISTING_CLICKED: 'job_listing_clicked',
  APPLY_CLICKED: 'apply_clicked',

  // Case Studies
  CASE_STUDY_CLICKED: 'case_study_clicked',
  CASE_STUDY_FILTER: 'case_study_filter',
  PDF_DOWNLOADED: 'pdf_downloaded',
  PDF_DOWNLOAD_ERROR: 'pdf_download_error',
  LEAD_CAPTURED: 'lead_captured',
  LEAD_SUBMITTED: 'lead_submitted',
  DOWNLOAD: 'download',

  // Help
  FAQ_EXPANDED: 'faq_expanded',
  CONTACT_SUPPORT_CLICKED: 'contact_support_clicked',

  // Documentation
  DOC_SEARCH_PERFORMED: 'doc_search_performed',
  DOC_FILTER_CHANGED: 'doc_filter_changed',
  DOC_FILE_DOWNLOADED: 'doc_file_downloaded',

  // Landing pages
  LANDING_CTA_CLICKED: 'landing_cta_clicked',
} as const;
